/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessNumberPagedResult } from '../../models/access-number-paged-result';
import { AccessNumberSearchRequest } from '../../models/access-number-search-request';

export interface PostAccessnumberSearch$Json$Params {
  'api-version'?: string;
      body?: AccessNumberSearchRequest
}

export function postAccessnumberSearch$Json(http: HttpClient, rootUrl: string, params?: PostAccessnumberSearch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AccessNumberPagedResult>> {
  const rb = new RequestBuilder(rootUrl, postAccessnumberSearch$Json.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccessNumberPagedResult>;
    })
  );
}

postAccessnumberSearch$Json.PATH = '/accessnumber/search';
